<template>
    <div class="company-article">
        <dl id="dl_en" class="hide">
        <dt>USING YOUR SPARE</dt>
        <dd>Most vehicles come equipped with a temporary spare. These tyres are usually much smaller than the other tyres on your car. It is important to realize that these spares have far more limitations than a typical tyre, including speed and recommended driving distance. Some spare tyres even require the use of a special canister to inflate the tyre. You should familiarize yourself with the spare by reading the owner's manual and the sidewall of the spare. And remember, check the air pressure of the spare frequently.</dd>
        <dt>HYDROPLANING</dt>
        <dd>Hydroplaning occurs when a vehicle begins to float on top of the water on a wet road. To reduce your risk of hydroplaning, slow down on wet roads.</dd>
        <dd>Three main factors contribute to hydroplaning, or the loss of traction on wet roads:</dd>
        <dd>A: Vehicle speed: As speed increases, wet traction is considerably reduced.<br/>
        B: Water depth: The deeper the water, the sooner you will lose traction, although even thin water layers can cause a loss of traction, even at low speeds.<br/>
        C: Tyre tread depth: As your tyres become worn, their ability to resist hydroplaning is reduced.
Since hydroplaning can result in a complete loss of traction and vehicle control, you should always reduce speed with consideration to the traffic around you.</dd>
        <dt>DRIVING ON ICE AND SNOW</dt>
        <dd>All-season tyres are designed to provide higher levels of snow traction than non-all-season tyres. You have all-season tyres if you find the letters "M+S" molded into the sidewall near the bead. These letters mean "Mud and Snow." Even the best all-season tyres will not provide acceptable levels of traction if you drive too fast in snow or icy conditions. Drive slowly and allow more stopping distance between cars. It could take up to 3-12 times more distance to stop on icy or snowy roads. Accelerate and decelerate slowly, and avoid making last minute decisions while driving.</dd>
        <dt>For Safe Winter Driving:</dt>
        <dd>Reduce your speed. Even good road conditions can deteriorate quickly.</dd>
        <dd>Anticipate up to 3-12 times increased stopping distance compared to dry road conditions. You may not always need that much distance, but when you do, you'll be glad you were playing it safe.</dd>
        <dd>Check the condition of your tyres. Worn tyres provide less grip.</dd>
        </dl>
        <dl id="dl_cn" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_es" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_ru" class="hide">
            <dd>test</dd>
        </dl>
    </div>
</template>
<script>
import $ from "jquery";
import Constants from "../../consts";
import VueCookies from "vue-cookies";
import consts from "../../consts";
export default {
  name: "Driving_Content",
  mounted: function() {
      $("#dl_en").addClass("show").removeClass("hide");
    // let lang = VueCookies.get(consts.COOKIE_LANG);
    // if (lang) {
    //   $("#dl_" + lang)
    //     .addClass("show")
    //     .removeClass("hide");
    // } else {
    //   $("#dl_en")
    //     .addClass("show")
    //     .removeClass("hide");
    // }
  }
};
</script>
<style>
.hide {
  display: none;
}
.show {
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/service/driving_content.vue